module.exports = __webpack_public_path__ + "img/u473.db468c95.png";